export const apiCreate = (): string => '/warehouse/productCategories/'
export const apiList = (id?: string): string =>
  !id
    ? '/warehouse/productCategories/'
    : `/warehouse/productCategories/view/${id}`
export const apiUpdate = (id: string): string =>
  `/warehouse/productCategories/update/${id}`
export const apiDelete = (id: string): string =>
  `/warehouse/productCategories/${id}`
